import HeaderComponent from "../../components/Header";
import axios from "axios";
import Image from "next/image";
import NavigationComponent from "../../components/HeaderNavigation";
import ProfileLayout from "../../components/ProfileLayout";
import { ToastContainer, toast } from "react-toastify";
import { useState, useEffect } from "react";
import moment from "moment";
import { useRouter } from "next/router";
import { toBackend } from "../../utilities/requestsTypes";
import { useSession } from "next-auth/react";

export default function Home() {

  const [allNotifications, setNotifications] = useState([]);

  const router = useRouter();
  const {data: session} = useSession();

  const loadNotifications = async () => {
    try {
      const res = await toBackend.get("notification", {
        headers: {
          accesstoken: session.user.token
        }
      });
      console.log(res.data);
      setNotifications(res.data);
    } catch (error) {
      console.log(error);
    }
  }

  const goToNotificaation = async (id, arg) => {

    const res = toBackend.get("notification/" + id, {
      headers: {
        accesstoken: session.user.token
      }
    });

    if(arg == "new-follow") {
      router.push("/profile");
    } else if(arg == "swap-request") {
      router.push("/profile/offers");
    }
  }

  useEffect(() => {
    loadNotifications();
  }, []);

  return (
    <div className="overflow-hidden h-full">
      <ToastContainer />
      <HeaderComponent />

      <hr />

      <NavigationComponent />

      <hr />

      <ProfileLayout>
        <div>
          <div className="flex justify-between w-[800px] mx-auto py-8">
            <div>Notifications</div>
            <div>
              <button>Mark all as read</button>
            </div>
          </div>

          <div className="w-[800px] mx-auto">
            {allNotifications.map((notification, index) => {
                if(notification.notificationType == "swap-request") {
                    return (
                      <div className={`flex items-center justify-between p-4 rounded-[10px] ${notification.seen == false ? "bg-primary/50" : ""}`} key={index} onClick={() => {goToNotificaation(notification._id, "swap-request")}}>
                        <div className="flex items-center gap-x-4">
                          <div
                            className={`h-[80px] w-[80px] rounded-full overflow-hidden`}
                          >
                            <Image
                              src={`/images/img2.png`}
                              height="20"
                              width="20"
                              layout="responsive"
                            />
                          </div>
                          <div className="w-[600px]">New Swap Request</div>
                        </div>
                        <div className="text-right">{moment(notification.createdAt).fromNow()}</div>
                      </div>
                  );
                } if(notification.notificationType == "new-follow") {
                  return (
                    <div className={`flex items-center justify-between p-4 rounded-[10px] ${notification.seen == false ? "bg-primary/50" : ""}`} key={index} onClick={() => {goToNotificaation(notification._id, "new-follow")}}>
                        <div className="flex items-center gap-x-4">
                          <div
                            className={`h-[80px] w-[80px] rounded-full overflow-hidden`}
                          >
                            <Image
                              src={`/images/img2.png`}
                              height="20"
                              width="20"
                              layout="responsive"
                            />
                          </div>
                          <div className="w-[600px]">New Follow</div>
                        </div>
                        <div className="text-right">{moment(notification.createdAt).fromNow()}</div>
                      </div>
                  );
                }
            })}
          </div>
        </div>
      </ProfileLayout>
    </div>
  );
}
